import { Footer } from '@/components/elements/new-footer/Footer'
import { SubNavigation } from '@/elements/global/SubNavigation'
import { ArticlesByCategory } from './Article/ArticlesByCategory'
import { LatestFeaturedArticles } from './Article/LatestFeaturedArticles'
import { HomepageContent } from './HomePage/HomepageContent'
import { Header } from '@/elements/header/Header'
import { SEOMetaTags } from '@/components/shared/SEOMetaTags'

export const AcademyHomePage = ({ homepage, categories, articlesByCategory, featuredArticles }) => {
  return (
    <>
      <SEOMetaTags metaData={homepage.metaData} path="/learn" />
      <Header />
      <SubNavigation title="Learn" categories={categories} />
      <main id="main-content">
        <HomepageContent page={homepage} />
        <LatestFeaturedArticles featuredArticles={featuredArticles} />
        {categories.map((category, categoryIndex) => {
          const articles = articlesByCategory[categoryIndex]
          return (
            <ArticlesByCategory
              key={category.id}
              categoryID={category.id}
              categoryName={category.categoryName}
              categorySlug={category.categorySlug}
              articles={articles}
              showHeader={true}
            />
          )
        })}
      </main>
      <Footer showPreFooter />
    </>
  )
}
